/**
 * Throw an error again.
 *
 * Handy for promise-based error handling.
 *
 * @example
 * ```
 *  const result = getPromise().catch(rethrow);
 * ```
 * @throws Error.
 */
export const rethrow = (err) => {
    throw err;
};
//# sourceMappingURL=rethrow.js.map